import { useContext, useState } from "react";
import Heading from "../UI/Heading";
import SearchBar from "../UI/SearchBar";
import { DataContext } from "../../context/data-context";
import PartnerCard from "./PartnerCard";
import { MdRefresh } from "react-icons/md";
import Smartcar from "@smartcar/auth";
import { RiSteeringFill } from "react-icons/ri";
import { fetchSmartcarAuth } from "../../api/fetch";
import { AuthContext } from "../../context/auth-context";

export default function Partners() {
  const { user } = useContext(AuthContext);
  const { partners, fetchPartners } = useContext(DataContext);
  const [filteredPartners, setFilteredPartners] = useState(partners);

  const onSetupSmartcar = async () => {
    try {
      const response = await fetchSmartcarAuth(user);
      const { link } = response;
      window.open(link, "_blank");
    } catch (err) {
      console.log(err.message);
    }
  };

  const searchHandler = (query) => {
    const filtered = partners.filter((partner) => {
      const partnerInfo = `${partner.name} ${partner.email} ${partner.phone}`;
      return partnerInfo.toLowerCase().includes(query.toLowerCase());
    });
    setFilteredPartners(filtered);
  };

  const clearSearchHandler = () => {
    setFilteredPartners(partners);
  };

  const refreshHandler = () => {
    fetchPartners();
  };

  return (
    <div className="container">
      <Heading title="Partners">
        <RiSteeringFill
          onClick={onSetupSmartcar}
          className="text-2xl text-white cursor-pointer hover:text-stone-400"
        />
        <MdRefresh
          onClick={refreshHandler}
          className="text-2xl text-white cursor-pointer hover:text-stone-400"
        />
      </Heading>

      <SearchBar
        searchHandler={searchHandler}
        clearSearch={clearSearchHandler}
      />

      <div className="h-[700px] overflow-scroll">
        <div className="grid gap-8">
          {filteredPartners.map((partner, idx) => (
            <PartnerCard key={idx} partner={partner} />
          ))}
        </div>
      </div>
    </div>
  );
}
